// // import {
// //   Alert,
// //   Backdrop,
// //   Box,
// //   Collapse,
// //   IconButton,
// //   Menu,
// //   MenuItem,
// // } from "@mui/material";
// // import React from "react";
// // import Loader from "../../components/Loader";
// // import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
// // import { logout } from "../../redux/actions/auth";
// // import { connect, useDispatch, useSelector } from "react-redux";
// // import { useState } from "react";
// // import { Link, useHistory, withRouter, useLocation } from "react-router-dom";
// // import Swal from "sweetalert2";
// // import { toast } from "react-toastify";
// // import Breadcrumbs from "./Breadcrumbs";
// // import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// // import { AccountCircle } from "@mui/icons-material";
// // import { useEffect } from "react";
// // import moment from "moment";
// // import Popover from "@mui/material/Popover";
// // import FireLogo from "../../assets/images/85154-01.png";
// // import DateRangePickerr from "./Dashboard/DateRangePicker";
// // import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// // import SettingsIcon from "@mui/icons-material/Settings";
// // import { addDays } from "date-fns";
// // import ForwardIcon from "@mui/icons-material/Forward";
// // import CloseIcon from "@mui/icons-material/Close";
// // import RefreshIcon from '@mui/icons-material/Refresh';
// // import { common_axios } from "../../App";
// // import Skeleton from "@mui/material/Skeleton";
// // import Whitelist from "./WhiteListing/Whitelist";
// // import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
// // import Tooltip from "@mui/material/Tooltip";
// // import ErrorIcon from "@mui/icons-material/Error";
// // import { setIn } from "formik";

// // function Navbar(props) {
// //   const history = useHistory();
// //   const [open, setOpen] = useState(false);
// //   const [credit, setCredit] = useState(false);
// // const[hideSkeleton,sethideSkeleton] = useState()
// //   const [navopen, setnavopen] = useState(false);
// //   const [truefalse, settruefalse] = useState(true);
// //   const [isOpen, setIsOpen] = useState(false);
// //   const [anchorEl, setAnchorEl] = React.useState(null);
// //   const [anchorEll, setAnchorEll] = React.useState(null);
// //   const selectedTime = useSelector(
// //     (state) => state.dashboardReducer.timeSeries
// //   );
// //   const handleClick = async (e) => {
// //     await props.logout();
// //     history.replace("/");
// //   };

// //   const passExpDays = JSON.parse(localStorage?.getItem("items"));

// //   // console.log("value of openav", navopen);

// //   const handleClose = () => {
// //     setAnchorEl(null);
// //   };
// //   // console.log({ props });

// //   // const navopen = () => {
// //   //   document.body.className = "g-sidenav-show bg-gray-200 g-sidenav-pinned";
// //   //   // settruefalse(true)
// //   // };

// //   if (
// //     document?.getElementById("main-section-sidebar")?.classList != undefined
// //   ) {
// //     if (navopen == false) {
// //       document.body.className = "g-sidenav-show bg-gray-200 ";
// //       const section = document?.getElementById("main-section-sidebar");
// //       section.classList.value = "sec_1";
// //     } else {
// //       document.body.className = "g-sidenav-show bg-gray-200 g-sidenav-pinned";
// //       const section = document?.getElementById("main-section-sidebar");
// //       section.classList.value = "sec_2";
// //     }
// //   }

// //   const location = useLocation();

// //   const loki = location.pathname;
// //   const handleMenu = (event) => {
// //     setAnchorEl(event.currentTarget);
// //   };

// //   useEffect(() => {
// //     if (
// //       props?.location?.pathname == "/" ||
// //       props?.location?.pathname == "/dashboard" ||
// //       props?.location?.pathname == "/Dashboard"
// //     ) {
// //       settruefalse(true);
// //     } else {
// //       settruefalse(false);
// //     }
// //   }, [props?.location?.pathname]);

// //   // console.log(
// //   //   moment(new Date()).add("days", 3),
// //   //   moment(new Date()).add("days", 3)._d,
// //   //   moment(passExpDays?.passwordExpireDate._d)
// //   // );

// //   var date = moment(passExpDays?.passwordExpireDate);
// //   var now = moment();

// //   // console.log(now);
// //   // console.log(date);

// //   const expDate = now.diff(date, "days");

// //   // console.log(expDate);

// //   // console.log("NNNNN", now.diff(date, "days"));

// //   async function CreditRefreshBtn(values) {
// //     // setTableLoader(true);
// //     sethideSkeleton(true);

// //     try {
// //       const result = await common_axios(`${process.env.REACT_APP_COMMON_API}/auth/v1/credit/check-credit`,);
// //       // console.log("------resultssss", result);
// //       if (result.data.statusDescription.statusCode == 200) {
// //              sethideSkeleton(false);
// // ;
// //          setCredit(result.data.credit);
// //         // await setScheduleTotalCount(result.data.scheduledList.totalElements);

// //         // setData(result.data.scheduledList.content);
// //         // await toast.success("success", {n
// //         //   theme: "colored",
// //         //   toastId: customId1,
// //         // });
// //       } else {
// //            sethideSkeleton(false);
// // ;
// //         // toast.error(result.data.statusDescription.statusMessage);
// //         Swal.fire({
// //           icon: "error",
// //           title: "Oops...",
// //           text: result.data.statusDescription.statusMessage,
// //           // footer: '<a href="">Why do I have this issue?</a>'
// //         });
// //       }

// //     } catch (error) {
// //       //   console.log(error);
// //            sethideSkeleton(false);
// // ;

// // Swal.fire({
// //   icon: "error",
// //   title: "Oops...",
// //   text: "Something went wrong",
// //   // footer: '<a href="">Why do I have this issue?</a>'
// // });
// //     }
// //     // console.log("response..", res);
// //   }

// // // .............................................................................//
// // async function CreditIntervalBtn(values) {
// //   // setTableLoader(true);
// //   // sethideSkeleton(true);

// //   try {
// //     const result = await common_axios(`${process.env.REACT_APP_COMMON_API}/auth/v1/credit/check-credit`,);
// //     // console.log("------resultssss", result);
// //     if (result.data.statusDescription.statusCode == 200) {
// //           //  sethideSkeleton(false);

// //        setCredit(result.data.credit);
// //        setTimeout(() => {
// //         CreditIntervalBtn();
// //       }, 30000);

// //       // setData(result.data.scheduledList.content);
// //       // await toast.success("success", {n
// //       //   theme: "colored",
// //       //   toastId: customId1,
// //       // });
// //     } else {
// //         //  sethideSkeleton(false);
// // ;
// //       // toast.error(result.data.statusDescription.statusMessage);
// //       Swal.fire({
// //         icon: "error",
// //         title: "Oops...",
// //         text: result.data.statusDescription.statusMessage,
// //         // footer: '<a href="">Why do I have this issue?</a>'
// //       });
// //     }

// //   } catch (error) {
// //     //   console.log(error);
// //         //  sethideSkeleton(false);
// // Swal.fire({
// // icon: "error",
// // title: "Oops...",
// // text: "Something went wrong",
// // // footer: '<a href="">Why do I have this issue?</a>'
// // });
// //   }
// //   // console.log("response..", res);
// // }

// // useEffect(()=>{
// //   CreditIntervalBtn()
// // },[])
// //   return (
// //     <>
// //       <header class="header_1 py-1">
// //         <div class="container-fluid">
// //           <div class="d-flex justify-content-between align-items-center">
// //             <Link to="/" class="d-block w_8">
// //               <img src={FireLogo} class="img-fluid d-block" />
// //             </Link>

// //             <div class="d-flex align-items-center">
// //               {/* <span class="d-block text-capitalize me-2">
// //                 Welcome [{localStorage.getItem("usernamedisplayed")}]
// //               </span> */}
// //               {/* {/ <span class="d-block text-capitalize">credit</span> /} */}
// //               <button
// //                     type="button"
// //                     className="btn w_btn m-0 px-0 search_1 refresh_credit1"
// //                 onClick={CreditRefreshBtn}
// //                   >
// //                     <RefreshIcon/>
// //                   </button>
// // {
// //   hideSkeleton==true?(<>    <Box sx={{width: 100}} >
// //                             <Skeleton />
// //                             {/* <Skeleton /> */}
// //                             <Skeleton animation={false} />
// //                           </Box>
// // </>):(<>
// // <span className="d-block text-capitalize ms-1 me-2">Credit : </span>
// //                   <span
// //                 class="d-block text-capitalize icon_txt"
// //                 style={{ fontSize: "19px", textShadow: "2px 2px #292a2d" }}
// //               >
// //                {
// //                 credit
// //                }
// //               </span>

// // {
// //   credit<1000  &&
// //   (
// //     <>

// //     <Tooltip title="Low credit please recharge" >
// //       <IconButton className="IcButton">
// //         <PriorityHighIcon className="err_ic"/>
// //       </IconButton>
// //       </Tooltip>

// //     </>
// //   )
// // }

// //   </>)
// // }

// //               <div className="lining mx-2"></div>
// //               <span class="d-block text-capitalize">
// //                 {localStorage.getItem("usernamedisplayed")}
// //               </span>
// //               {/* <span
// //                 class="d-block text-capitalize mx-2"
// //                 style={{ fontSize: "21px", textShadow: "2px 2px #292a2d" }}
// //               >
// //                 {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
// //                 "ROLE_SUPER_ADMIN"
// //                   ? "₹12105.80"
// //                   : JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
// //                     "ROLE_RESELLER"
// //                   ? "₹15525.60"
// //                   : "₹7255.85"}
// //               </span>
// //               <span class="d-block text-capitalize me-2">
// //                 {localStorage.getItem("usernamedisplayed")}
// //               </span> */}
// //               {/* <div class="dropdown mx-4">
// //                 <a
// //                   class="btn btn_admin dropdown-toggle text-capitalize d-flex align-items-center p-0"
// //                   href="#"
// //                   role="button"
// //                   id="dropdownMenuLink"
// //                   data-bs-toggle="dropdown"
// //                   aria-expanded="false"
// //                 >
// //                   <span class="d-block me-1">admin</span>
// //                 </a>

// //                 <div
// //                   class="dropdown-menu sbn_mnq"
// //                   aria-labelledby="dropdownMenuLink"
// //                 >
// //                   <div
// //                     class="dropdown-item d-flex align-items-center text-capitalize"
// //                     href="#"
// //                   >
// //                     <i
// //                       class="fas fa-check fa-fw d-block"
// //                       aria-hidden="true"
// //                     ></i>
// //                     <span class="d-block w-100 ms-2">view assigned assets</span>
// //                   </div>
// //                   <div
// //                     class="dropdown-item d-flex align-items-center text-capitalize"
// //                     href="#"
// //                   >
// //                     <i
// //                       class="fas fa-check fa-fw d-block"
// //                       aria-hidden="true"
// //                     ></i>
// //                     <span class="d-block w-100 ms-2">requested assets</span>
// //                   </div>
// //                   <div
// //                     class="dropdown-item d-flex align-items-center text-capitalize"
// //                     href="#"
// //                   >
// //                     <i
// //                       class="fas fa-check fa-fw d-block"
// //                       aria-hidden="true"
// //                     ></i>
// //                     <span class="d-block w-100 ms-2">accept assets</span>
// //                   </div>
// //                   <div
// //                     class="dropdown-item d-flex align-items-center text-capitalize"
// //                     href="#"
// //                   >
// //                     <i class="fas fa-user fa-fw d-block" aria-hidden="true"></i>
// //                     <span class="d-block w-100 ms-2">edit your profile</span>
// //                   </div>
// //                   <div
// //                     class="dropdown-item d-flex align-items-center text-capitalize"
// //                     href="#"
// //                   >
// //                     <i class="fas fa-asterisk d-block" aria-hidden="true"></i>
// //                     <span class="d-block w-100 ms-2">change password</span>
// //                   </div>
// //                   <div
// //                     class="dropdown-item d-flex align-items-center text-capitalize"
// //                     href="#"
// //                   >
// //                     <i
// //                       class="fas fa-user-secret d-block"
// //                       aria-hidden="true"
// //                     ></i>
// //                     <span class="d-block w-100 ms-2">manage API keys</span>
// //                   </div>
// //                   <div class="divider"></div>
// //                   <div
// //                     class="dropdown-item d-flex align-items-center text-capitalize"
// //                     href="#"
// //                   >
// //                     <i
// //                       class="fa fa-sign-out fa-fw d-block"
// //                       aria-hidden="true"
// //                     ></i>
// //                     <span class="d-block w-100 ms-2">logout</span>
// //                   </div>
// //                 </div>
// //               </div> */}

// //               <IconButton
// //                 size="large"
// //                 aria-label="account of current user"
// //                 aria-controls="menu-appbar"
// //                 aria-haspopup="true"
// //                 onClick={handleMenu}
// //                 color="inherit"
// //                 className="mx-1"
// //                 style={{ color: "#ffff" }}
// //               >
// //                 <AccountCircle />
// //               </IconButton>
// //               <Menu
// //                 id="menu-appbar"
// //                 anchorEl={anchorEl}
// //                 // anchorOrigin={{
// //                 //   vertical: "bottom",
// //                 //   horizontal: "left",
// //                 // }}
// //                 // transformOrigin={{
// //                 //   vertical: "center",
// //                 //   horizontal: "right",
// //                 // }}
// //                 keepMounted
// //                 open={Boolean(anchorEl)}
// //                 onClose={handleClose}
// //               >
// //                 <Link to="/dashboard/profile">
// //                   <MenuItem onClick={handleClose}>View Profile</MenuItem>
// //                 </Link>
// //                 <MenuItem onClick={handleClick}>Sign Out</MenuItem>
// //                 {/* <Link to="/dashboard/updatepassword">
// //                       <MenuItem onClick={handleClose}>Update Password</MenuItem>
// //                     </Link>
// //                     <Link to="/dashboard/updateaccount">
// //                       <MenuItem onClick={handleClose}>Update account</MenuItem>
// //                     </Link> */}
// //               </Menu>
// //               {/* <Link to="/settings">
// //                 <IconButton
// //                   variant="text"
// //                   size="small"
// //                   sx={{
// //                     color: "#ffff",
// //                   }}
// //                 >
// //                   <SettingsIcon />
// //                 </IconButton>
// //               </Link> */}

// //               <li
// //                 className="nav-item ps-3 d-lg-none d-flex align-items-center"
// //                 onClick={() => setIsOpen(!isOpen)}
// //               >
// //                 <a
// //                   className="nav-link text-body p-0"
// //                   id="iconNavbarSidenav"
// //                   style={{ cursor: "pointer" }}
// //                   onClick={() => setnavopen(!navopen)}
// //                 >
// //                   <div className="sidenav-toggler-inner">
// //                     <i className="sidenav-toggler-line"></i>
// //                     <i className="sidenav-toggler-line"></i>
// //                     <i className="sidenav-toggler-line"></i>
// //                   </div>
// //                 </a>
// //               </li>
// //             </div>
// //           </div>
// //         </div>
// //       </header>

// //       <nav
// //         class="navbar navbar-main navbar-expand-lg px-0 shadow-none border-radius-xl my-2"
// //         id="navbarBlur"
// //         navbar-scroll="true"
// //       >
// //         <div class="container-fluid">
// //           <Breadcrumbs />

// //           {loki != "/dashboard/profile" ? (
// //             <>
// //               <div>
// //                 {now.diff(date, "days") == -2 ? (
// //                   <>
// //                     <div
// //                       class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
// //                       role="alert"
// //                       style={{ marginBottom: "auto" }}
// //                     >
// //                       <div>
// //                         <strong>
// //                           Your Password would expire in
// //                           {/* {String(now.diff(date, "days")).split("-")[1]}  */}
// //                           2 Days
// //                         </strong>
// //                       </div>
// //                       <Link className="ms-3" to="/dashboard/profile">
// //                         Click Here .! <PanToolAltIcon />
// //                       </Link>
// //                       <button
// //                         style={{ color: "black" }}
// //                         type="button"
// //                         class="btn-close py-0"
// //                         data-bs-dismiss="alert"
// //                         aria-label="Close"
// //                       ></button>
// //                     </div>
// //                   </>
// //                 ) : now.diff(date, "days") == -1 ? (
// //                   <>
// //                     <div
// //                       class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
// //                       role="alert"
// //                       style={{ marginBottom: "auto" }}
// //                     >
// //                       <div>
// //                         <strong>
// //                           Your Password would expire in 1
// //                           {/* {String(now.diff(date, "days")).split("-")[1]}  */}
// //                           Day
// //                         </strong>
// //                       </div>
// //                       <Link className="ms-3" to="/dashboard/profile">
// //                         Click Here .! <PanToolAltIcon />
// //                       </Link>
// //                       <button
// //                         style={{ color: "black" }}
// //                         type="button"
// //                         class="btn-close py-0"
// //                         data-bs-dismiss="alert"
// //                         aria-label="Close"
// //                       ></button>
// //                     </div>
// //                   </>
// //                 ) : now.diff(date, "days") == 0 ? (
// //                   <>
// //                     <div
// //                       class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
// //                       role="alert"
// //                       style={{ marginBottom: "auto" }}
// //                     >
// //                       <div>
// //                         <strong>Your Password will expire Today</strong>
// //                       </div>
// //                       <Link className="ms-3" to="/dashboard/profile">
// //                         Click Here .! <PanToolAltIcon />
// //                       </Link>
// //                       <button
// //                         style={{ color: "black" }}
// //                         type="button"
// //                         class="btn-close py-0"
// //                         data-bs-dismiss="alert"
// //                         aria-label="Close"
// //                       ></button>
// //                     </div>
// //                   </>
// //                 ) : null}
// //               </div>
// //             </>
// //           ) : null}
// //           {/* {passExpDays?.passExpIndays < 31 ? ( */}

// //           {/* {passExpDays?.passExpIndays < 31 ? (
// //             <>
// //               <Box sx={{ width: "100%" }}>
// //                 <Collapse in={open}>
// //                   <Alert
// //                     action={
// //                       <IconButton
// //                         aria-label="close"
// //                         color="inherit"
// //                         size="small"
// //                       >
// //                         <CloseIcon fontSize="inherit" />
// //                       </IconButton>
// //                     }
// //                     sx={{ mb: 2 }}
// //                   >
// //                     Close me!
// //                   </Alert>
// //                 </Collapse>{" "}
// //               </Box>
// //             </>
// //           ) : (
// //             <>null</>
// //           )} */}

// //           {/* <div
// //             class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
// //             style={{ flexGrow: "unset" }}
// //             id="navbar"
// //           >
// //             <ul class="navbar-nav  justify-content-end">
// //               <li class="nav-item d-flex align-items-center">
// //                 <a
// //                   href="javascript:;"
// //                   class="nav-link text-body font-weight-bold px-0"
// //                 >
// //                   <i class="fa fa-user me-sm-1"></i>
// //                   <span class="d-sm-inline d-none">Welcome [superuser]</span>
// //                 </a>
// //               </li>
// //               <li class="nav-item d-flex align-items-center px-3">
// //                 <a
// //                   href="javascript:;"
// //                   class="nav-link text-body font-weight-bold px-0"
// //                 >
// //                   <i class="fas fa-sign-out-alt fa-fw me-sm-1"></i>
// //                   <span class="d-sm-inline d-none">Sign Out</span>
// //                 </a>
// //               </li>
// //               <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
// //                 <a
// //                   href="javascript:;"
// //                   class="nav-link text-body p-0"
// //                   id="iconNavbarSidenav"
// //                 >
// //                   <div class="sidenav-toggler-inner">
// //                     <i class="sidenav-toggler-line"></i>
// //                     <i class="sidenav-toggler-line"></i>
// //                     <i class="sidenav-toggler-line"></i>
// //                   </div>
// //                 </a>
// //               </li>
// //             </ul>
// //           </div> */}

// //           <div
// //             class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
// //             style={{ flexGrow: "unset" }}
// //             id="navbar"
// //           >
// //             <ul class="navbar-nav  justify-content-end">
// //               {/* <li class="nav-item d-flex align-items-center">
// //                 {truefalse && (
// //                   <>
// //                     {selectedTime.start ==
// //                     moment(new Date()).format("DD-MM-YYYY") ? (
// //                       <span
// //                         className="d-sm-inline ms_2 start_date_time_css"
// //                         style={{ backgroundColor: "#3c8dbc", color: "white" }}
// //                       >
// //                         Today
// //                       </span>
// //                     ) : selectedTime.start ==
// //                       moment(addDays(new Date(), -1)).format("DD-MM-YYYY") ? (
// //                       <span
// //                         style={{ backgroundColor: "#3c8dbc", color: "white" }}
// //                         className="d-sm-inline ms_2 start_date_time_css"
// //                       >
// //                         Yesterday
// //                       </span>
// //                     ) : (
// //                       <>
// //                         <span
// //                           style={{ backgroundColor: "#3c8dbc", color: "white" }}
// //                           className="d-sm-inline ms_2 start_date_time_css"
// //                         >
// //                           {selectedTime.start}
// //                         </span>
// //                         <ForwardIcon />
// //                         <span
// //                           style={{ backgroundColor: "#3c8dbc", color: "white" }}
// //                           className="d-sm-inline mx_2 start_date_time_css"
// //                         >
// //                           {selectedTime.end}
// //                         </span>
// //                       </>
// //                     )}
// //                     <IconButton
// //                       variant="text"
// //                       size="small"
// //                       sx={{
// //                         color: "rgba(0, 0, 0, 0.6)",
// //                       }}
// //                       // className="btn bg-gradient-primary "
// //                       aria-describedby={
// //                         Boolean(anchorEll) ? "simple-popover" : undefined
// //                       }
// //                       onClick={(event) => {
// //                         setAnchorEll(event.currentTarget);
// //                       }}
// //                     >
// //                       <CalendarMonthIcon />
// //                     </IconButton>

// //                     <Popover
// //                       id={Boolean(anchorEll) ? "simple-popover" : undefined}
// //                       open={Boolean(anchorEll)}
// //                       anchorEl={anchorEll}
// //                       onClose={() => {
// //                         setAnchorEll(null);
// //                       }}
// //                       anchorOrigin={{
// //                         vertical: "bottom",
// //                         horizontal: "left",
// //                       }}
// //                       transformOrigin={{
// //                         vertical: "top",
// //                         horizontal: "left",
// //                       }}
// //                     >
// //                       <DateRangePickerr />
// //                     </Popover>
// //                   </>
// //                 )}
// //               </li> */}

// //               <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
// //                 <a
// //                   href="javascript:;"
// //                   class="nav-link text-body p-0"
// //                   id="iconNavbarSidenav"
// //                 >
// //                   <div class="sidenav-toggler-inner">
// //                     <i class="sidenav-toggler-line"></i>
// //                     <i class="sidenav-toggler-line"></i>
// //                     <i class="sidenav-toggler-line"></i>
// //                   </div>
// //                 </a>
// //               </li>
// //             </ul>
// //           </div>
// //         </div>
// //       </nav>

// //       <nav
// //         className="navbar navbar-main navbar-expand-lg px-0 shadow-none border-radius-xl heading_1 d-none"
// //         id="navbarBlur"
// //         navbar-scroll="true"
// //       >
// //         <Backdrop
// //           sx={{
// //             transform: "translateZ(0)",
// //             color: "#fff",
// //             zIndex: (theme) => theme.zIndex.drawer + 1,
// //           }}
// //           open={open}
// //           // onClick={handleClose}
// //         >
// //           <Loader />
// //         </Backdrop>

// //         <div className="container-fluid">
// //           <nav aria-label="breadcrumb" className="bread">
// //             <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
// //               <li className="breadcrumb-item text-sm">
// //                 <Breadcrumbs />
// //               </li>
// //             </ol>
// //           </nav>
// //           {/* <nav aria-label="breadcrumb">
// //               <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
// //                 <li class="breadcrumb-item text-sm">
// //                   <a class="opacity-5 text-dark" href="javascript:;">
// //                     MIS Account
// //                   </a>
// //                 </li>
// //                 <li
// //                   class="breadcrumb-item text-sm text-dark active"
// //                   aria-current="page"
// //                 >
// //                   Add Account
// //                 </li>
// //               </ol>
// //             </nav> */}

// //           <div
// //             className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
// //             id="navbar"
// //           >
// //             <ul className="navbar-nav  justify-content-end">
// //               <li className="nav-item d-flex align-items-center me-2">
// //                 <a href="" className="nav-link text-body font-weight-bold px-0">
// //                   <i className="fa fa-user me-sm-1"></i>
// //                   <span className="d-sm-inline ms_2">
// //                     Welcome [{localStorage.getItem("usernamedisplayed")}]
// //                   </span>
// //                 </a>
// //               </li>
// //               {/* <button
// //                 onClick={handleClick}
// //                 id="logout"
// //                 key="logout"
// //                 className="nav-link text-body font-weight-bold ms_2 px-0"
// //                 style={{ border: "none", marginLeft: "10px" }}
// //               >
// //                 <i className="fas fa-sign-out-alt fa-fw me-sm-1"></i>
// //                 <span className="d-sm-inline d-none">Sign Out</span>
// //               </button> */}
// //               {truefalse && (
// //                 <>
// //                   <span className="d-sm-inline ms_2">{selectedTime.start}</span>
// //                   <span className="d-sm-inline ms_2">{selectedTime.end}</span>
// //                   <IconButton
// //                     variant="text"
// //                     size="small"
// //                     sx={{
// //                       color: "#7B809A",
// //                     }}
// //                     // className="btn bg-gradient-primary "
// //                     aria-describedby={
// //                       Boolean(anchorEll) ? "simple-popover" : undefined
// //                     }
// //                     onClick={(event) => {
// //                       setAnchorEll(event.currentTarget);
// //                     }}
// //                   >
// //                     <CalendarMonthIcon />
// //                   </IconButton>

// //                   <Popover
// //                     id={Boolean(anchorEll) ? "simple-popover" : undefined}
// //                     open={Boolean(anchorEll)}
// //                     anchorEl={anchorEll}
// //                     onClose={() => {
// //                       setAnchorEll(null);
// //                     }}
// //                     anchorOrigin={{
// //                       vertical: "bottom",
// //                       horizontal: "left",
// //                     }}
// //                     transformOrigin={{
// //                       vertical: "top",
// //                       horizontal: "left",
// //                     }}
// //                   >
// //                     <DateRangePickerr />
// //                   </Popover>
// //                 </>
// //               )}

// //               <li
// //                 className="nav-item ps-3 d-lg-none d-flex align-items-center"
// //                 onClick={() => setIsOpen(!isOpen)}
// //               >
// //                 <a
// //                   className="nav-link text-body p-0"
// //                   id="iconNavbarSidenav"
// //                   style={{ cursor: "pointer" }}
// //                   onClick={() => setnavopen(!navopen)}
// //                 >
// //                   <div className="sidenav-toggler-inner">
// //                     <i className="sidenav-toggler-line"></i>
// //                     <i className="sidenav-toggler-line"></i>
// //                     <i className="sidenav-toggler-line"></i>
// //                   </div>
// //                 </a>
// //               </li>
// //             </ul>
// //           </div>
// //         </div>
// //       </nav>
// //     </>
// //   );
// // }

// // const mapStateToProps = (state) => (
// //   // console.log(state, "state"),
// //   {
// //     username: state.authReducer.username,
// //   }
// // );

// // const mapDispatchToProps = (dispatch) => ({
// //   logout: () => dispatch(logout(localStorage.getItem("Username"))),
// // });

// // export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));

// import {
//   Alert,
//   Backdrop,
//   Box,
//   Collapse,
//   IconButton,
//   Menu,
//   MenuItem,
// } from "@mui/material";
// import React from "react";
// import Loader from "../../components/Loader";
// import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
// import { logout } from "../../redux/actions/auth";
// import { connect, useDispatch, useSelector } from "react-redux";
// import { useState } from "react";
// import { Link, useHistory, withRouter, useLocation } from "react-router-dom";
// import Swal from "sweetalert2";
// import { toast } from "react-toastify";
// import Breadcrumbs from "./Breadcrumbs";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import { AccountCircle } from "@mui/icons-material";
// import { useEffect } from "react";
// import moment from "moment";
// import Popover from "@mui/material/Popover";
// // import FireLogo from "../../assets/images/85154-01.png";
// // import FireLogo from "../../assets/images/Moovlogo_sidebar.png"
// // import FireLogo from "../../assets/images/Navbar_moovlogo.jpg"
// import FireLogo from "../../assets/images/Moovlogo_sidebar-min.png";
// import DateRangePickerr from "./Dashboard/DateRangePicker";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import SettingsIcon from "@mui/icons-material/Settings";
// import { addDays } from "date-fns";
// import ForwardIcon from "@mui/icons-material/Forward";
// import CloseIcon from "@mui/icons-material/Close";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import { common_axios } from "../../App";
// import Skeleton from "@mui/material/Skeleton";
// import Whitelist from "./WhiteListing/Whitelist";
// import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
// import Tooltip from "@mui/material/Tooltip";
// import ErrorIcon from "@mui/icons-material/Error";
// import { setIn } from "formik";

// function Navbar(props) {
//   const history = useHistory();
//   const [open, setOpen] = useState(false);
//   const [credit, setCredit] = useState(false);
//   const [hideSkeleton, sethideSkeleton] = useState();
//   const [navopen, setnavopen] = useState(false);
//   const [truefalse, settruefalse] = useState(true);
//   const [isOpen, setIsOpen] = useState(false);
//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const [anchorEll, setAnchorEll] = React.useState(null);
//   const selectedTime = useSelector(
//     (state) => state.dashboardReducer.timeSeries
//   );
//   const handleClick = async (e) => {
//     await props.logout();
//     history.replace("/");
//   };

//   const passExpDays = JSON.parse(localStorage?.getItem("items"));

//   // console.log("value of openav", navopen);

//   const handleClose = () => {
//     setAnchorEl(null);
//   };
//   // console.log({ props });

//   // const navopen = () => {
//   //   document.body.className = "g-sidenav-show bg-gray-200 g-sidenav-pinned";
//   //   // settruefalse(true)
//   // };

//   if (
//     document?.getElementById("main-section-sidebar")?.classList != undefined
//   ) {
//     if (navopen == false) {
//       document.body.className = "g-sidenav-show bg-gray-200 ";
//       const section = document?.getElementById("main-section-sidebar");
//       section.classList.value = "sec_1";
//     } else {
//       document.body.className = "g-sidenav-show bg-gray-200 g-sidenav-pinned";
//       const section = document?.getElementById("main-section-sidebar");
//       section.classList.value = "sec_2";
//     }
//   }

//   const location = useLocation();
//   // console.log("lo--", location);

//   const loki = location.pathname;
//   const handleMenu = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   useEffect(() => {
//     if (
//       props?.location?.pathname == "/" ||
//       props?.location?.pathname == "/dashboard" ||
//       props?.location?.pathname == "/Dashboard"
//     ) {
//       settruefalse(true);
//     } else {
//       settruefalse(false);
//     }
//   }, [props?.location?.pathname]);

//   // console.log(
//   //   moment(new Date()).add("days", 3),
//   //   moment(new Date()).add("days", 3)._d,
//   //   moment(passExpDays?.passwordExpireDate._d)
//   // );

//   var date = moment(passExpDays?.passwordExpireDate);
//   var now = moment();

//   // console.log(now);
//   // console.log(date);

//   const expDate = now.diff(date, "days");

//   // console.log(expDate);

//   // console.log("NNNNN", now.diff(date, "days"));
// // .................................................................................................................................................//
//   async function CreditRefreshBtn(values) {
//     // setTableLoader(true);
//     sethideSkeleton(true);

//     try {
//       const result = await common_axios(
//         `${process.env.REACT_APP_COMMON_API}/auth/v1/credit/check-credit`
//       );
//       // console.log("------resultssss", result);
//       if (result.data.statusDescription.statusCode == 200) {
//         sethideSkeleton(false);
//         setCredit(result.data.credit);
//         // await setScheduleTotalCount(result.data.scheduledList.totalElements);

//         // setData(result.data.scheduledList.content);
//         // await toast.success("success", {n
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//       } else {
//         sethideSkeleton(false);
//         // toast.error(result.data.statusDescription.statusMessage);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       //   console.log(error);
//       sethideSkeleton(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//     // console.log("response..", res);
//   }

//   // ...................................................................................................................................//
//   async function CreditIntervalBtn(values) {
//     // setTableLoader(true);
//     // sethideSkeleton(true);

//     try {
//       const result = await common_axios(
//         `${process.env.REACT_APP_COMMON_API}/auth/v1/credit/check-credit`
//       );
//       // console.log("------resultssss", result);
//       if (result.data.statusDescription.statusCode == 200) {
//         //  sethideSkeleton(false);

//         setCredit(result.data.credit);
//         // setTimeout(() => {
//         //   CreditIntervalBtn();
//         // }, 10000);

//         // setData(result.data.scheduledList.content);
//         // await toast.success("success", {n
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//       } else {
//         //  sethideSkeleton(false);
//         // toast.error(result.data.statusDescription.statusMessage);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       //   console.log(error);
//       //  sethideSkeleton(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//     // console.log("response..", res);
//   }

//   useEffect(() => {
//     CreditIntervalBtn();
//   }, []);
//   // ----------------------------------------------------Credit api in setinterval---------------------------------------------------//

//   const [intervalId, setIntervalId] = useState(null);

//   useEffect(() => {
//     const id = setInterval(() => {
//       if (localStorage.getItem("token")) {
//         CreditIntervalBtn();
//       }    }, 30000);
//     setIntervalId(id);

//     return () => {
//       clearInterval(intervalId);
//     };
//   }, []);

//   useEffect(() => {
//     const handleRouteChange = () => {
//       // Stop the setInterval when the user logs out and navigates to the login page
//       clearInterval(intervalId);
//     };

//     history.listen(handleRouteChange);

//     return () => {
//       // history?.unlisten(handleRouteChange);
//     };
//   }, [history, intervalId]);

//   // -----------------------------------End credit api in setinterval----------------------------------
//   return (
//     <>
//       <header class="header_1 py-1">
//         <div class="container-fluid">
//           <div class="d-flex justify-content-between align-items-center">
//             <Link to="/" class="d-block" style={{width:"6rem"}}>
//               <img src={FireLogo} class="img-fluid d-block" />
//             </Link>

//             <div class="d-flex align-items-center">
//               {/* <span class="d-block text-capitalize me-2">
//                 Welcome [{localStorage.getItem("usernamedisplayed")}]
//               </span> */}
//               {/* {/ <span class="d-block text-capitalize">credit</span> /} */}
//               <button
//                 type="button"
//                 className="btn w_btn m-0 px-0 search_1 refresh_credit1"
//                 onClick={CreditRefreshBtn}
//               >
//                 <RefreshIcon />
//               </button>
//               {hideSkeleton == true ? (
//                 <>
//                   {" "}
//                   <Box sx={{ width: 100 }}>
//                     <Skeleton />
//                     {/* <Skeleton /> */}
//                     <Skeleton animation={false} />
//                   </Box>
//                 </>
//               ) : (
//                 <>
//                   <span className="d-block text-capitalize ms-1 me-2">
//                     Credit :{" "}
//                   </span>
//                   <span
//                     class="d-block text-capitalize icon_txt"
//                     style={{ fontSize: "19px"}}
//                   >
// {credit ? credit?.toLocaleString("en-US") : 0}

//                   </span>

//                   {credit < 1000 && (
//                     <>
//                       <Tooltip title="Low credit please recharge">
//                         <IconButton className="IcButton">
//                           <PriorityHighIcon className="err_ic" />
//                         </IconButton>
//                       </Tooltip>
//                     </>
//                   )}
//                 </>
//               )}

//               <div className="lining mx-2"></div>
//               <span class="d-block text-capitalize">
//                 {localStorage.getItem("usernamedisplayed")}
//               </span>
//               {/* <span
//                 class="d-block text-capitalize mx-2"
//                 style={{ fontSize: "21px", textShadow: "2px 2px #292a2d" }}
//               >
//                 {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//                 "ROLE_SUPER_ADMIN"
//                   ? "₹12105.80"
//                   : JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//                     "ROLE_RESELLER"
//                   ? "₹15525.60"
//                   : "₹7255.85"}
//               </span>
//               <span class="d-block text-capitalize me-2">
//                 {localStorage.getItem("usernamedisplayed")}
//               </span> */}
//               {/* <div class="dropdown mx-4">
//                 <a
//                   class="btn btn_admin dropdown-toggle text-capitalize d-flex align-items-center p-0"
//                   href="#"
//                   role="button"
//                   id="dropdownMenuLink"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                 >
//                   <span class="d-block me-1">admin</span>
//                 </a>

//                 <div
//                   class="dropdown-menu sbn_mnq"
//                   aria-labelledby="dropdownMenuLink"
//                 >
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i
//                       class="fas fa-check fa-fw d-block"
//                       aria-hidden="true"
//                     ></i>
//                     <span class="d-block w-100 ms-2">view assigned assets</span>
//                   </div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i
//                       class="fas fa-check fa-fw d-block"
//                       aria-hidden="true"
//                     ></i>
//                     <span class="d-block w-100 ms-2">requested assets</span>
//                   </div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i
//                       class="fas fa-check fa-fw d-block"
//                       aria-hidden="true"
//                     ></i>
//                     <span class="d-block w-100 ms-2">accept assets</span>
//                   </div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i class="fas fa-user fa-fw d-block" aria-hidden="true"></i>
//                     <span class="d-block w-100 ms-2">edit your profile</span>
//                   </div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i class="fas fa-asterisk d-block" aria-hidden="true"></i>
//                     <span class="d-block w-100 ms-2">change password</span>
//                   </div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i
//                       class="fas fa-user-secret d-block"
//                       aria-hidden="true"
//                     ></i>
//                     <span class="d-block w-100 ms-2">manage API keys</span>
//                   </div>
//                   <div class="divider"></div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i
//                       class="fa fa-sign-out fa-fw d-block"
//                       aria-hidden="true"
//                     ></i>
//                     <span class="d-block w-100 ms-2">logout</span>
//                   </div>
//                 </div>
//               </div> */}

//               <IconButton
//                 size="large"
//                 aria-label="account of current user"
//                 aria-controls="menu-appbar"
//                 aria-haspopup="true"
//                 onClick={handleMenu}
//                 color="inherit"
//                 className="mx-1"
//                 style={{ color: "#ffff" }}
//               >
//                 <AccountCircle />
//               </IconButton>
//               <Menu
//                 id="menu-appbar"
//                 anchorEl={anchorEl}
//                 // anchorOrigin={{
//                 //   vertical: "bottom",
//                 //   horizontal: "left",
//                 // }}
//                 // transformOrigin={{
//                 //   vertical: "center",
//                 //   horizontal: "right",
//                 // }}
//                 keepMounted
//                 open={Boolean(anchorEl)}
//                 onClose={handleClose}
//               >
//                 <Link to="/dashboard/profile">
//                   <MenuItem onClick={handleClose}>View Profile</MenuItem>
//                 </Link>
//                 <MenuItem onClick={handleClick}>Sign Out</MenuItem>
//                 {/* <Link to="/dashboard/updatepassword">
//                       <MenuItem onClick={handleClose}>Update Password</MenuItem>
//                     </Link>
//                     <Link to="/dashboard/updateaccount">
//                       <MenuItem onClick={handleClose}>Update account</MenuItem>
//                     </Link> */}
//               </Menu>
//               {/* <Link to="/settings">
//                 <IconButton
//                   variant="text"
//                   size="small"
//                   sx={{
//                     color: "#ffff",
//                   }}
//                 >
//                   <SettingsIcon />
//                 </IconButton>
//               </Link> */}

//               <li
//                 className="nav-item ps-3 d-lg-none d-flex align-items-center"
//                 onClick={() => setIsOpen(!isOpen)}
//               >
//                 <a
//                   className="nav-link text-body p-0"
//                   id="iconNavbarSidenav"
//                   style={{ cursor: "pointer" }}
//                   onClick={() => setnavopen(!navopen)}
//                 >
//                   <div className="sidenav-toggler-inner">
//                     <i className="sidenav-toggler-line"></i>
//                     <i className="sidenav-toggler-line"></i>
//                     <i className="sidenav-toggler-line"></i>
//                   </div>
//                 </a>
//               </li>
//             </div>
//           </div>
//         </div>
//       </header>

//       <nav
//         class="navbar navbar-main navbar-expand-lg px-0 shadow-none border-radius-xl my-2"
//         id="navbarBlur"
//         navbar-scroll="true"
//       >
//         <div class="container-fluid">
//           <Breadcrumbs />

//           {loki != "/dashboard/profile" ? (
//             <>
//               <div>
//                 {now.diff(date, "days") == -2 ? (
//                   <>
//                     <div
//                       class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
//                       role="alert"
//                       style={{ marginBottom: "auto" }}
//                     >
//                       <div>
//                         <strong>
//                           Your Password would expire in
//                           {/* {String(now.diff(date, "days")).split("-")[1]}  */}
//                           2 Days
//                         </strong>
//                       </div>
//                       <Link className="ms-3" to="/dashboard/profile">
//                         Click Here .! <PanToolAltIcon />
//                       </Link>
//                       <button
//                         style={{ color: "black" }}
//                         type="button"
//                         class="btn-close py-0"
//                         data-bs-dismiss="alert"
//                         aria-label="Close"
//                       ></button>
//                     </div>
//                   </>
//                 ) : now.diff(date, "days") == -1 ? (
//                   <>
//                     <div
//                       class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
//                       role="alert"
//                       style={{ marginBottom: "auto" }}
//                     >
//                       <div>
//                         <strong>
//                           Your Password would expire in 1
//                           {/* {String(now.diff(date, "days")).split("-")[1]}  */}
//                           Day
//                         </strong>
//                       </div>
//                       <Link className="ms-3" to="/dashboard/profile">
//                         Click Here .! <PanToolAltIcon />
//                       </Link>
//                       <button
//                         style={{ color: "black" }}
//                         type="button"
//                         class="btn-close py-0"
//                         data-bs-dismiss="alert"
//                         aria-label="Close"
//                       ></button>
//                     </div>
//                   </>
//                 ) : now.diff(date, "days") == 0 ? (
//                   <>
//                     <div
//                       class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
//                       role="alert"
//                       style={{ marginBottom: "auto" }}
//                     >
//                       <div>
//                         <strong>Your Password will expire Today</strong>
//                       </div>
//                       <Link className="ms-3" to="/dashboard/profile">
//                         Click Here .! <PanToolAltIcon />
//                       </Link>
//                       <button
//                         style={{ color: "black" }}
//                         type="button"
//                         class="btn-close py-0"
//                         data-bs-dismiss="alert"
//                         aria-label="Close"
//                       ></button>
//                     </div>
//                   </>
//                 ) : null}
//               </div>
//             </>
//           ) : null}
//           {/* {passExpDays?.passExpIndays < 31 ? ( */}

//           {/* {passExpDays?.passExpIndays < 31 ? (
//             <>
//               <Box sx={{ width: "100%" }}>
//                 <Collapse in={open}>
//                   <Alert
//                     action={
//                       <IconButton
//                         aria-label="close"
//                         color="inherit"
//                         size="small"
//                       >
//                         <CloseIcon fontSize="inherit" />
//                       </IconButton>
//                     }
//                     sx={{ mb: 2 }}
//                   >
//                     Close me!
//                   </Alert>
//                 </Collapse>{" "}
//               </Box>
//             </>
//           ) : (
//             <>null</>
//           )} */}

//           {/* <div
//             class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
//             style={{ flexGrow: "unset" }}
//             id="navbar"
//           >
//             <ul class="navbar-nav  justify-content-end">
//               <li class="nav-item d-flex align-items-center">
//                 <a
//                   href="javascript:;"
//                   class="nav-link text-body font-weight-bold px-0"
//                 >
//                   <i class="fa fa-user me-sm-1"></i>
//                   <span class="d-sm-inline d-none">Welcome [superuser]</span>
//                 </a>
//               </li>
//               <li class="nav-item d-flex align-items-center px-3">
//                 <a
//                   href="javascript:;"
//                   class="nav-link text-body font-weight-bold px-0"
//                 >
//                   <i class="fas fa-sign-out-alt fa-fw me-sm-1"></i>
//                   <span class="d-sm-inline d-none">Sign Out</span>
//                 </a>
//               </li>
//               <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
//                 <a
//                   href="javascript:;"
//                   class="nav-link text-body p-0"
//                   id="iconNavbarSidenav"
//                 >
//                   <div class="sidenav-toggler-inner">
//                     <i class="sidenav-toggler-line"></i>
//                     <i class="sidenav-toggler-line"></i>
//                     <i class="sidenav-toggler-line"></i>
//                   </div>
//                 </a>
//               </li>
//             </ul>
//           </div> */}

//           <div
//             class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
//             style={{ flexGrow: "unset" }}
//             id="navbar"
//           >
//             <ul class="navbar-nav  justify-content-end">
//               {/* <li class="nav-item d-flex align-items-center">
//                 {truefalse && (
//                   <>
//                     {selectedTime.start ==
//                     moment(new Date()).format("DD-MM-YYYY") ? (
//                       <span
//                         className="d-sm-inline ms_2 start_date_time_css"
//                         style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                       >
//                         Today
//                       </span>
//                     ) : selectedTime.start ==
//                       moment(addDays(new Date(), -1)).format("DD-MM-YYYY") ? (
//                       <span
//                         style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                         className="d-sm-inline ms_2 start_date_time_css"
//                       >
//                         Yesterday
//                       </span>
//                     ) : (
//                       <>
//                         <span
//                           style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                           className="d-sm-inline ms_2 start_date_time_css"
//                         >
//                           {selectedTime.start}
//                         </span>
//                         <ForwardIcon />
//                         <span
//                           style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                           className="d-sm-inline mx_2 start_date_time_css"
//                         >
//                           {selectedTime.end}
//                         </span>
//                       </>
//                     )}
//                     <IconButton
//                       variant="text"
//                       size="small"
//                       sx={{
//                         color: "rgba(0, 0, 0, 0.6)",
//                       }}
//                       // className="btn bg-gradient-primary "
//                       aria-describedby={
//                         Boolean(anchorEll) ? "simple-popover" : undefined
//                       }
//                       onClick={(event) => {
//                         setAnchorEll(event.currentTarget);
//                       }}
//                     >
//                       <CalendarMonthIcon />
//                     </IconButton>

//                     <Popover
//                       id={Boolean(anchorEll) ? "simple-popover" : undefined}
//                       open={Boolean(anchorEll)}
//                       anchorEl={anchorEll}
//                       onClose={() => {
//                         setAnchorEll(null);
//                       }}
//                       anchorOrigin={{
//                         vertical: "bottom",
//                         horizontal: "left",
//                       }}
//                       transformOrigin={{
//                         vertical: "top",
//                         horizontal: "left",
//                       }}
//                     >
//                       <DateRangePickerr />
//                     </Popover>
//                   </>
//                 )}
//               </li> */}

//               <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
//                 <a
//                   href="javascript:;"
//                   class="nav-link text-body p-0"
//                   id="iconNavbarSidenav"
//                 >
//                   <div class="sidenav-toggler-inner">
//                     <i class="sidenav-toggler-line"></i>
//                     <i class="sidenav-toggler-line"></i>
//                     <i class="sidenav-toggler-line"></i>
//                   </div>
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>

//       <nav
//         className="navbar navbar-main navbar-expand-lg px-0 shadow-none border-radius-xl heading_1 d-none"
//         id="navbarBlur"
//         navbar-scroll="true"
//       >
//         <Backdrop
//           sx={{
//             transform: "translateZ(0)",
//             color: "#fff",
//             zIndex: (theme) => theme.zIndex.drawer + 1,
//           }}
//           open={open}
//           // onClick={handleClose}
//         >
//           <Loader />
//         </Backdrop>

//         <div className="container-fluid">
//           <nav aria-label="breadcrumb" className="bread">
//             <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
//               <li className="breadcrumb-item text-sm">
//                 <Breadcrumbs />
//               </li>
//             </ol>
//           </nav>
//           {/* <nav aria-label="breadcrumb">
//               <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
//                 <li class="breadcrumb-item text-sm">
//                   <a class="opacity-5 text-dark" href="javascript:;">
//                     MIS Account
//                   </a>
//                 </li>
//                 <li
//                   class="breadcrumb-item text-sm text-dark active"
//                   aria-current="page"
//                 >
//                   Add Account
//                 </li>
//               </ol>
//             </nav> */}

//           <div
//             className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
//             id="navbar"
//           >
//             <ul className="navbar-nav  justify-content-end">
//               <li className="nav-item d-flex align-items-center me-2">
//                 <a href="" className="nav-link text-body font-weight-bold px-0">
//                   <i className="fa fa-user me-sm-1"></i>
//                   <span className="d-sm-inline ms_2">
//                     Welcome [{localStorage.getItem("usernamedisplayed")}]
//                   </span>
//                 </a>
//               </li>
//               {/* <button
//                 onClick={handleClick}
//                 id="logout"
//                 key="logout"
//                 className="nav-link text-body font-weight-bold ms_2 px-0"
//                 style={{ border: "none", marginLeft: "10px" }}
//               >
//                 <i className="fas fa-sign-out-alt fa-fw me-sm-1"></i>
//                 <span className="d-sm-inline d-none">Sign Out</span>
//               </button> */}
//               {truefalse && (
//                 <>
//                   <span className="d-sm-inline ms_2">{selectedTime.start}</span>
//                   <span className="d-sm-inline ms_2">{selectedTime.end}</span>
//                   <IconButton
//                     variant="text"
//                     size="small"
//                     sx={{
//                       color: "#7B809A",
//                     }}
//                     // className="btn bg-gradient-primary "
//                     aria-describedby={
//                       Boolean(anchorEll) ? "simple-popover" : undefined
//                     }
//                     onClick={(event) => {
//                       setAnchorEll(event.currentTarget);
//                     }}
//                   >
//                     <CalendarMonthIcon />
//                   </IconButton>

//                   <Popover
//                     id={Boolean(anchorEll) ? "simple-popover" : undefined}
//                     open={Boolean(anchorEll)}
//                     anchorEl={anchorEll}
//                     onClose={() => {
//                       setAnchorEll(null);
//                     }}
//                     anchorOrigin={{
//                       vertical: "bottom",
//                       horizontal: "left",
//                     }}
//                     transformOrigin={{
//                       vertical: "top",
//                       horizontal: "left",
//                     }}
//                   >
//                     <DateRangePickerr />
//                   </Popover>
//                 </>
//               )}

//               <li
//                 className="nav-item ps-3 d-lg-none d-flex align-items-center"
//                 onClick={() => setIsOpen(!isOpen)}
//               >
//                 <a
//                   className="nav-link text-body p-0"
//                   id="iconNavbarSidenav"
//                   style={{ cursor: "pointer" }}
//                   onClick={() => setnavopen(!navopen)}
//                 >
//                   <div className="sidenav-toggler-inner">
//                     <i className="sidenav-toggler-line"></i>
//                     <i className="sidenav-toggler-line"></i>
//                     <i className="sidenav-toggler-line"></i>
//                   </div>
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>
//     </>
//   );
// }

// const mapStateToProps = (state) =>
//   // console.log(state, "state"),
//   ({
//     username: state.authReducer.username,
//   });

// const mapDispatchToProps = (dispatch) => ({
//   logout: () => dispatch(logout(localStorage.getItem("Username"))),
// });

// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));

// import {
//   Alert,
//   Backdrop,
//   Box,
//   Collapse,
//   IconButton,
//   Menu,
//   MenuItem,
// } from "@mui/material";
// import React from "react";
// import Loader from "../../components/Loader";
// import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
// import { logout } from "../../redux/actions/auth";
// import { connect, useDispatch, useSelector } from "react-redux";
// import { useState } from "react";
// import { Link, useHistory, withRouter, useLocation } from "react-router-dom";
// import Swal from "sweetalert2";
// import { toast } from "react-toastify";
// import Breadcrumbs from "./Breadcrumbs";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import { AccountCircle } from "@mui/icons-material";
// import { useEffect } from "react";
// import moment from "moment";
// import Popover from "@mui/material/Popover";
// import FireLogo from "../../assets/images/85154-01.png";
// import DateRangePickerr from "./Dashboard/DateRangePicker";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import SettingsIcon from "@mui/icons-material/Settings";
// import { addDays } from "date-fns";
// import ForwardIcon from "@mui/icons-material/Forward";
// import CloseIcon from "@mui/icons-material/Close";
// import RefreshIcon from '@mui/icons-material/Refresh';
// import { common_axios } from "../../App";
// import Skeleton from "@mui/material/Skeleton";
// import Whitelist from "./WhiteListing/Whitelist";
// import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
// import Tooltip from "@mui/material/Tooltip";
// import ErrorIcon from "@mui/icons-material/Error";
// import { setIn } from "formik";

// function Navbar(props) {
//   const history = useHistory();
//   const [open, setOpen] = useState(false);
//   const [credit, setCredit] = useState(false);
// const[hideSkeleton,sethideSkeleton] = useState()
//   const [navopen, setnavopen] = useState(false);
//   const [truefalse, settruefalse] = useState(true);
//   const [isOpen, setIsOpen] = useState(false);
//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const [anchorEll, setAnchorEll] = React.useState(null);
//   const selectedTime = useSelector(
//     (state) => state.dashboardReducer.timeSeries
//   );
//   const handleClick = async (e) => {
//     await props.logout();
//     history.replace("/");
//   };

//   const passExpDays = JSON.parse(localStorage?.getItem("items"));

//   // console.log("value of openav", navopen);

//   const handleClose = () => {
//     setAnchorEl(null);
//   };
//   // console.log({ props });

//   // const navopen = () => {
//   //   document.body.className = "g-sidenav-show bg-gray-200 g-sidenav-pinned";
//   //   // settruefalse(true)
//   // };

//   if (
//     document?.getElementById("main-section-sidebar")?.classList != undefined
//   ) {
//     if (navopen == false) {
//       document.body.className = "g-sidenav-show bg-gray-200 ";
//       const section = document?.getElementById("main-section-sidebar");
//       section.classList.value = "sec_1";
//     } else {
//       document.body.className = "g-sidenav-show bg-gray-200 g-sidenav-pinned";
//       const section = document?.getElementById("main-section-sidebar");
//       section.classList.value = "sec_2";
//     }
//   }

//   const location = useLocation();

//   const loki = location.pathname;
//   const handleMenu = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   useEffect(() => {
//     if (
//       props?.location?.pathname == "/" ||
//       props?.location?.pathname == "/dashboard" ||
//       props?.location?.pathname == "/Dashboard"
//     ) {
//       settruefalse(true);
//     } else {
//       settruefalse(false);
//     }
//   }, [props?.location?.pathname]);

//   // console.log(
//   //   moment(new Date()).add("days", 3),
//   //   moment(new Date()).add("days", 3)._d,
//   //   moment(passExpDays?.passwordExpireDate._d)
//   // );

//   var date = moment(passExpDays?.passwordExpireDate);
//   var now = moment();

//   // console.log(now);
//   // console.log(date);

//   const expDate = now.diff(date, "days");

//   // console.log(expDate);

//   // console.log("NNNNN", now.diff(date, "days"));

//   async function CreditRefreshBtn(values) {
//     // setTableLoader(true);
//     sethideSkeleton(true);

//     try {
//       const result = await common_axios(`${process.env.REACT_APP_COMMON_API}/auth/v1/credit/check-credit`,);
//       // console.log("------resultssss", result);
//       if (result.data.statusDescription.statusCode == 200) {
//              sethideSkeleton(false);
// ;
//          setCredit(result.data.credit);
//         // await setScheduleTotalCount(result.data.scheduledList.totalElements);

//         // setData(result.data.scheduledList.content);
//         // await toast.success("success", {n
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//       } else {
//            sethideSkeleton(false);
// ;
//         // toast.error(result.data.statusDescription.statusMessage);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }

//     } catch (error) {
//       //   console.log(error);
//            sethideSkeleton(false);
// ;

// Swal.fire({
//   icon: "error",
//   title: "Oops...",
//   text: "Something went wrong",
//   // footer: '<a href="">Why do I have this issue?</a>'
// });
//     }
//     // console.log("response..", res);
//   }

// // .............................................................................//
// async function CreditIntervalBtn(values) {
//   // setTableLoader(true);
//   // sethideSkeleton(true);

//   try {
//     const result = await common_axios(`${process.env.REACT_APP_COMMON_API}/auth/v1/credit/check-credit`,);
//     // console.log("------resultssss", result);
//     if (result.data.statusDescription.statusCode == 200) {
//           //  sethideSkeleton(false);

//        setCredit(result.data.credit);
//        setTimeout(() => {
//         CreditIntervalBtn();
//       }, 30000);

//       // setData(result.data.scheduledList.content);
//       // await toast.success("success", {n
//       //   theme: "colored",
//       //   toastId: customId1,
//       // });
//     } else {
//         //  sethideSkeleton(false);
// ;
//       // toast.error(result.data.statusDescription.statusMessage);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: result.data.statusDescription.statusMessage,
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }

//   } catch (error) {
//     //   console.log(error);
//         //  sethideSkeleton(false);
// Swal.fire({
// icon: "error",
// title: "Oops...",
// text: "Something went wrong",
// // footer: '<a href="">Why do I have this issue?</a>'
// });
//   }
//   // console.log("response..", res);
// }

// useEffect(()=>{
//   CreditIntervalBtn()
// },[])
//   return (
//     <>
//       <header class="header_1 py-1">
//         <div class="container-fluid">
//           <div class="d-flex justify-content-between align-items-center">
//             <Link to="/" class="d-block w_8">
//               <img src={FireLogo} class="img-fluid d-block" />
//             </Link>

//             <div class="d-flex align-items-center">
//               {/* <span class="d-block text-capitalize me-2">
//                 Welcome [{localStorage.getItem("usernamedisplayed")}]
//               </span> */}
//               {/* {/ <span class="d-block text-capitalize">credit</span> /} */}
//               <button
//                     type="button"
//                     className="btn w_btn m-0 px-0 search_1 refresh_credit1"
//                 onClick={CreditRefreshBtn}
//                   >
//                     <RefreshIcon/>
//                   </button>
// {
//   hideSkeleton==true?(<>    <Box sx={{width: 100}} >
//                             <Skeleton />
//                             {/* <Skeleton /> */}
//                             <Skeleton animation={false} />
//                           </Box>
// </>):(<>
// <span className="d-block text-capitalize ms-1 me-2">Credit : </span>
//                   <span
//                 class="d-block text-capitalize icon_txt"
//                 style={{ fontSize: "19px", textShadow: "2px 2px #292a2d" }}
//               >
//                {
//                 credit
//                }
//               </span>

// {
//   credit<1000  &&
//   (
//     <>

//     <Tooltip title="Low credit please recharge" >
//       <IconButton className="IcButton">
//         <PriorityHighIcon className="err_ic"/>
//       </IconButton>
//       </Tooltip>

//     </>
//   )
// }

//   </>)
// }

//               <div className="lining mx-2"></div>
//               <span class="d-block text-capitalize">
//                 {localStorage.getItem("usernamedisplayed")}
//               </span>
//               {/* <span
//                 class="d-block text-capitalize mx-2"
//                 style={{ fontSize: "21px", textShadow: "2px 2px #292a2d" }}
//               >
//                 {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//                 "ROLE_SUPER_ADMIN"
//                   ? "₹12105.80"
//                   : JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//                     "ROLE_RESELLER"
//                   ? "₹15525.60"
//                   : "₹7255.85"}
//               </span>
//               <span class="d-block text-capitalize me-2">
//                 {localStorage.getItem("usernamedisplayed")}
//               </span> */}
//               {/* <div class="dropdown mx-4">
//                 <a
//                   class="btn btn_admin dropdown-toggle text-capitalize d-flex align-items-center p-0"
//                   href="#"
//                   role="button"
//                   id="dropdownMenuLink"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                 >
//                   <span class="d-block me-1">admin</span>
//                 </a>

//                 <div
//                   class="dropdown-menu sbn_mnq"
//                   aria-labelledby="dropdownMenuLink"
//                 >
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i
//                       class="fas fa-check fa-fw d-block"
//                       aria-hidden="true"
//                     ></i>
//                     <span class="d-block w-100 ms-2">view assigned assets</span>
//                   </div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i
//                       class="fas fa-check fa-fw d-block"
//                       aria-hidden="true"
//                     ></i>
//                     <span class="d-block w-100 ms-2">requested assets</span>
//                   </div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i
//                       class="fas fa-check fa-fw d-block"
//                       aria-hidden="true"
//                     ></i>
//                     <span class="d-block w-100 ms-2">accept assets</span>
//                   </div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i class="fas fa-user fa-fw d-block" aria-hidden="true"></i>
//                     <span class="d-block w-100 ms-2">edit your profile</span>
//                   </div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i class="fas fa-asterisk d-block" aria-hidden="true"></i>
//                     <span class="d-block w-100 ms-2">change password</span>
//                   </div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i
//                       class="fas fa-user-secret d-block"
//                       aria-hidden="true"
//                     ></i>
//                     <span class="d-block w-100 ms-2">manage API keys</span>
//                   </div>
//                   <div class="divider"></div>
//                   <div
//                     class="dropdown-item d-flex align-items-center text-capitalize"
//                     href="#"
//                   >
//                     <i
//                       class="fa fa-sign-out fa-fw d-block"
//                       aria-hidden="true"
//                     ></i>
//                     <span class="d-block w-100 ms-2">logout</span>
//                   </div>
//                 </div>
//               </div> */}

//               <IconButton
//                 size="large"
//                 aria-label="account of current user"
//                 aria-controls="menu-appbar"
//                 aria-haspopup="true"
//                 onClick={handleMenu}
//                 color="inherit"
//                 className="mx-1"
//                 style={{ color: "#ffff" }}
//               >
//                 <AccountCircle />
//               </IconButton>
//               <Menu
//                 id="menu-appbar"
//                 anchorEl={anchorEl}
//                 // anchorOrigin={{
//                 //   vertical: "bottom",
//                 //   horizontal: "left",
//                 // }}
//                 // transformOrigin={{
//                 //   vertical: "center",
//                 //   horizontal: "right",
//                 // }}
//                 keepMounted
//                 open={Boolean(anchorEl)}
//                 onClose={handleClose}
//               >
//                 <Link to="/dashboard/profile">
//                   <MenuItem onClick={handleClose}>View Profile</MenuItem>
//                 </Link>
//                 <MenuItem onClick={handleClick}>Sign Out</MenuItem>
//                 {/* <Link to="/dashboard/updatepassword">
//                       <MenuItem onClick={handleClose}>Update Password</MenuItem>
//                     </Link>
//                     <Link to="/dashboard/updateaccount">
//                       <MenuItem onClick={handleClose}>Update account</MenuItem>
//                     </Link> */}
//               </Menu>
//               {/* <Link to="/settings">
//                 <IconButton
//                   variant="text"
//                   size="small"
//                   sx={{
//                     color: "#ffff",
//                   }}
//                 >
//                   <SettingsIcon />
//                 </IconButton>
//               </Link> */}

//               <li
//                 className="nav-item ps-3 d-lg-none d-flex align-items-center"
//                 onClick={() => setIsOpen(!isOpen)}
//               >
//                 <a
//                   className="nav-link text-body p-0"
//                   id="iconNavbarSidenav"
//                   style={{ cursor: "pointer" }}
//                   onClick={() => setnavopen(!navopen)}
//                 >
//                   <div className="sidenav-toggler-inner">
//                     <i className="sidenav-toggler-line"></i>
//                     <i className="sidenav-toggler-line"></i>
//                     <i className="sidenav-toggler-line"></i>
//                   </div>
//                 </a>
//               </li>
//             </div>
//           </div>
//         </div>
//       </header>

//       <nav
//         class="navbar navbar-main navbar-expand-lg px-0 shadow-none border-radius-xl my-2"
//         id="navbarBlur"
//         navbar-scroll="true"
//       >
//         <div class="container-fluid">
//           <Breadcrumbs />

//           {loki != "/dashboard/profile" ? (
//             <>
//               <div>
//                 {now.diff(date, "days") == -2 ? (
//                   <>
//                     <div
//                       class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
//                       role="alert"
//                       style={{ marginBottom: "auto" }}
//                     >
//                       <div>
//                         <strong>
//                           Your Password would expire in
//                           {/* {String(now.diff(date, "days")).split("-")[1]}  */}
//                           2 Days
//                         </strong>
//                       </div>
//                       <Link className="ms-3" to="/dashboard/profile">
//                         Click Here .! <PanToolAltIcon />
//                       </Link>
//                       <button
//                         style={{ color: "black" }}
//                         type="button"
//                         class="btn-close py-0"
//                         data-bs-dismiss="alert"
//                         aria-label="Close"
//                       ></button>
//                     </div>
//                   </>
//                 ) : now.diff(date, "days") == -1 ? (
//                   <>
//                     <div
//                       class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
//                       role="alert"
//                       style={{ marginBottom: "auto" }}
//                     >
//                       <div>
//                         <strong>
//                           Your Password would expire in 1
//                           {/* {String(now.diff(date, "days")).split("-")[1]}  */}
//                           Day
//                         </strong>
//                       </div>
//                       <Link className="ms-3" to="/dashboard/profile">
//                         Click Here .! <PanToolAltIcon />
//                       </Link>
//                       <button
//                         style={{ color: "black" }}
//                         type="button"
//                         class="btn-close py-0"
//                         data-bs-dismiss="alert"
//                         aria-label="Close"
//                       ></button>
//                     </div>
//                   </>
//                 ) : now.diff(date, "days") == 0 ? (
//                   <>
//                     <div
//                       class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
//                       role="alert"
//                       style={{ marginBottom: "auto" }}
//                     >
//                       <div>
//                         <strong>Your Password will expire Today</strong>
//                       </div>
//                       <Link className="ms-3" to="/dashboard/profile">
//                         Click Here .! <PanToolAltIcon />
//                       </Link>
//                       <button
//                         style={{ color: "black" }}
//                         type="button"
//                         class="btn-close py-0"
//                         data-bs-dismiss="alert"
//                         aria-label="Close"
//                       ></button>
//                     </div>
//                   </>
//                 ) : null}
//               </div>
//             </>
//           ) : null}
//           {/* {passExpDays?.passExpIndays < 31 ? ( */}

//           {/* {passExpDays?.passExpIndays < 31 ? (
//             <>
//               <Box sx={{ width: "100%" }}>
//                 <Collapse in={open}>
//                   <Alert
//                     action={
//                       <IconButton
//                         aria-label="close"
//                         color="inherit"
//                         size="small"
//                       >
//                         <CloseIcon fontSize="inherit" />
//                       </IconButton>
//                     }
//                     sx={{ mb: 2 }}
//                   >
//                     Close me!
//                   </Alert>
//                 </Collapse>{" "}
//               </Box>
//             </>
//           ) : (
//             <>null</>
//           )} */}

//           {/* <div
//             class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
//             style={{ flexGrow: "unset" }}
//             id="navbar"
//           >
//             <ul class="navbar-nav  justify-content-end">
//               <li class="nav-item d-flex align-items-center">
//                 <a
//                   href="javascript:;"
//                   class="nav-link text-body font-weight-bold px-0"
//                 >
//                   <i class="fa fa-user me-sm-1"></i>
//                   <span class="d-sm-inline d-none">Welcome [superuser]</span>
//                 </a>
//               </li>
//               <li class="nav-item d-flex align-items-center px-3">
//                 <a
//                   href="javascript:;"
//                   class="nav-link text-body font-weight-bold px-0"
//                 >
//                   <i class="fas fa-sign-out-alt fa-fw me-sm-1"></i>
//                   <span class="d-sm-inline d-none">Sign Out</span>
//                 </a>
//               </li>
//               <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
//                 <a
//                   href="javascript:;"
//                   class="nav-link text-body p-0"
//                   id="iconNavbarSidenav"
//                 >
//                   <div class="sidenav-toggler-inner">
//                     <i class="sidenav-toggler-line"></i>
//                     <i class="sidenav-toggler-line"></i>
//                     <i class="sidenav-toggler-line"></i>
//                   </div>
//                 </a>
//               </li>
//             </ul>
//           </div> */}

//           <div
//             class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
//             style={{ flexGrow: "unset" }}
//             id="navbar"
//           >
//             <ul class="navbar-nav  justify-content-end">
//               {/* <li class="nav-item d-flex align-items-center">
//                 {truefalse && (
//                   <>
//                     {selectedTime.start ==
//                     moment(new Date()).format("DD-MM-YYYY") ? (
//                       <span
//                         className="d-sm-inline ms_2 start_date_time_css"
//                         style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                       >
//                         Today
//                       </span>
//                     ) : selectedTime.start ==
//                       moment(addDays(new Date(), -1)).format("DD-MM-YYYY") ? (
//                       <span
//                         style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                         className="d-sm-inline ms_2 start_date_time_css"
//                       >
//                         Yesterday
//                       </span>
//                     ) : (
//                       <>
//                         <span
//                           style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                           className="d-sm-inline ms_2 start_date_time_css"
//                         >
//                           {selectedTime.start}
//                         </span>
//                         <ForwardIcon />
//                         <span
//                           style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                           className="d-sm-inline mx_2 start_date_time_css"
//                         >
//                           {selectedTime.end}
//                         </span>
//                       </>
//                     )}
//                     <IconButton
//                       variant="text"
//                       size="small"
//                       sx={{
//                         color: "rgba(0, 0, 0, 0.6)",
//                       }}
//                       // className="btn bg-gradient-primary "
//                       aria-describedby={
//                         Boolean(anchorEll) ? "simple-popover" : undefined
//                       }
//                       onClick={(event) => {
//                         setAnchorEll(event.currentTarget);
//                       }}
//                     >
//                       <CalendarMonthIcon />
//                     </IconButton>

//                     <Popover
//                       id={Boolean(anchorEll) ? "simple-popover" : undefined}
//                       open={Boolean(anchorEll)}
//                       anchorEl={anchorEll}
//                       onClose={() => {
//                         setAnchorEll(null);
//                       }}
//                       anchorOrigin={{
//                         vertical: "bottom",
//                         horizontal: "left",
//                       }}
//                       transformOrigin={{
//                         vertical: "top",
//                         horizontal: "left",
//                       }}
//                     >
//                       <DateRangePickerr />
//                     </Popover>
//                   </>
//                 )}
//               </li> */}

//               <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
//                 <a
//                   href="javascript:;"
//                   class="nav-link text-body p-0"
//                   id="iconNavbarSidenav"
//                 >
//                   <div class="sidenav-toggler-inner">
//                     <i class="sidenav-toggler-line"></i>
//                     <i class="sidenav-toggler-line"></i>
//                     <i class="sidenav-toggler-line"></i>
//                   </div>
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>

//       <nav
//         className="navbar navbar-main navbar-expand-lg px-0 shadow-none border-radius-xl heading_1 d-none"
//         id="navbarBlur"
//         navbar-scroll="true"
//       >
//         <Backdrop
//           sx={{
//             transform: "translateZ(0)",
//             color: "#fff",
//             zIndex: (theme) => theme.zIndex.drawer + 1,
//           }}
//           open={open}
//           // onClick={handleClose}
//         >
//           <Loader />
//         </Backdrop>

//         <div className="container-fluid">
//           <nav aria-label="breadcrumb" className="bread">
//             <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
//               <li className="breadcrumb-item text-sm">
//                 <Breadcrumbs />
//               </li>
//             </ol>
//           </nav>
//           {/* <nav aria-label="breadcrumb">
//               <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
//                 <li class="breadcrumb-item text-sm">
//                   <a class="opacity-5 text-dark" href="javascript:;">
//                     MIS Account
//                   </a>
//                 </li>
//                 <li
//                   class="breadcrumb-item text-sm text-dark active"
//                   aria-current="page"
//                 >
//                   Add Account
//                 </li>
//               </ol>
//             </nav> */}

//           <div
//             className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
//             id="navbar"
//           >
//             <ul className="navbar-nav  justify-content-end">
//               <li className="nav-item d-flex align-items-center me-2">
//                 <a href="" className="nav-link text-body font-weight-bold px-0">
//                   <i className="fa fa-user me-sm-1"></i>
//                   <span className="d-sm-inline ms_2">
//                     Welcome [{localStorage.getItem("usernamedisplayed")}]
//                   </span>
//                 </a>
//               </li>
//               {/* <button
//                 onClick={handleClick}
//                 id="logout"
//                 key="logout"
//                 className="nav-link text-body font-weight-bold ms_2 px-0"
//                 style={{ border: "none", marginLeft: "10px" }}
//               >
//                 <i className="fas fa-sign-out-alt fa-fw me-sm-1"></i>
//                 <span className="d-sm-inline d-none">Sign Out</span>
//               </button> */}
//               {truefalse && (
//                 <>
//                   <span className="d-sm-inline ms_2">{selectedTime.start}</span>
//                   <span className="d-sm-inline ms_2">{selectedTime.end}</span>
//                   <IconButton
//                     variant="text"
//                     size="small"
//                     sx={{
//                       color: "#7B809A",
//                     }}
//                     // className="btn bg-gradient-primary "
//                     aria-describedby={
//                       Boolean(anchorEll) ? "simple-popover" : undefined
//                     }
//                     onClick={(event) => {
//                       setAnchorEll(event.currentTarget);
//                     }}
//                   >
//                     <CalendarMonthIcon />
//                   </IconButton>

//                   <Popover
//                     id={Boolean(anchorEll) ? "simple-popover" : undefined}
//                     open={Boolean(anchorEll)}
//                     anchorEl={anchorEll}
//                     onClose={() => {
//                       setAnchorEll(null);
//                     }}
//                     anchorOrigin={{
//                       vertical: "bottom",
//                       horizontal: "left",
//                     }}
//                     transformOrigin={{
//                       vertical: "top",
//                       horizontal: "left",
//                     }}
//                   >
//                     <DateRangePickerr />
//                   </Popover>
//                 </>
//               )}

//               <li
//                 className="nav-item ps-3 d-lg-none d-flex align-items-center"
//                 onClick={() => setIsOpen(!isOpen)}
//               >
//                 <a
//                   className="nav-link text-body p-0"
//                   id="iconNavbarSidenav"
//                   style={{ cursor: "pointer" }}
//                   onClick={() => setnavopen(!navopen)}
//                 >
//                   <div className="sidenav-toggler-inner">
//                     <i className="sidenav-toggler-line"></i>
//                     <i className="sidenav-toggler-line"></i>
//                     <i className="sidenav-toggler-line"></i>
//                   </div>
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>
//     </>
//   );
// }

// const mapStateToProps = (state) => (
//   // console.log(state, "state"),
//   {
//     username: state.authReducer.username,
//   }
// );

// const mapDispatchToProps = (dispatch) => ({
//   logout: () => dispatch(logout(localStorage.getItem("Username"))),
// });

// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));

import {
  Alert,
  Backdrop,
  Box,
  Collapse,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import React from "react";
import Loader from "../../components/Loader";
import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
import { logout } from "../../redux/actions/auth";
import { connect, useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { Link, useHistory, withRouter, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Breadcrumbs from "./Breadcrumbs";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { AccountCircle } from "@mui/icons-material";
import { useEffect } from "react";
import moment from "moment";
import Popover from "@mui/material/Popover";
import FireLogo from "../../assets/images/85154-01.png";
import DateRangePickerr from "./Dashboard/DateRangePicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SettingsIcon from "@mui/icons-material/Settings";
import { addDays } from "date-fns";
import ForwardIcon from "@mui/icons-material/Forward";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import { common_axios } from "../../App";
import Skeleton from "@mui/material/Skeleton";
import Whitelist from "./WhiteListing/Whitelist";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Tooltip from "@mui/material/Tooltip";
import ErrorIcon from "@mui/icons-material/Error";
import { setIn } from "formik";
import MenuIcon from "@mui/icons-material/Menu";
function Navbar(props) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [credit, setCredit] = useState(false);
  const [hideSkeleton, sethideSkeleton] = useState();
  const [navopen, setnavopen] = useState(false);
  const [truefalse, settruefalse] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEll, setAnchorEll] = React.useState(null);
  const selectedTime = useSelector(
    (state) => state.dashboardReducer.timeSeries
  );
  const handleClick = async (e) => {
    await props.logout();
    history.replace("/");
  };

  const passExpDays = JSON.parse(localStorage?.getItem("items"));

  // console.log("value of openav", navopen);

  const handleClose = () => {
    setAnchorEl(null);
  };
  // console.log({ props });

  // const navopen = () => {
  //   document.body.className = "g-sidenav-show bg-gray-200 g-sidenav-pinned";
  //   // settruefalse(true)
  // };

  if (
    document?.getElementById("main-section-sidebar")?.classList != undefined
  ) {
    if (navopen == false) {
      document.body.className = "g-sidenav-show bg-gray-200 ";
      const section = document?.getElementById("main-section-sidebar");
      section.classList.value = "sec_1";
    } else {
      document.body.className = "g-sidenav-show bg-gray-200 g-sidenav-pinned";
      const section = document?.getElementById("main-section-sidebar");
      section.classList.value = "sec_2";
    }
  }

  const location = useLocation();
  // console.log("lo--", location);

  const loki = location.pathname;
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (
      props?.location?.pathname == "/" ||
      props?.location?.pathname == "/dashboard" ||
      props?.location?.pathname == "/Dashboard"
    ) {
      settruefalse(true);
    } else {
      settruefalse(false);
    }
  }, [props?.location?.pathname]);

  // console.log(
  //   moment(new Date()).add("days", 3),
  //   moment(new Date()).add("days", 3)._d,
  //   moment(passExpDays?.passwordExpireDate._d)
  // );

  var date = moment(passExpDays?.passwordExpireDate);
  var now = moment();

  // console.log(now);
  // console.log(date);

  const expDate = now.diff(date, "days");

  // console.log(expDate);

  // console.log("NNNNN", now.diff(date, "days"));

  async function CreditRefreshBtn(values) {
    // setTableLoader(true);
    sethideSkeleton(true);

    try {
      const result = await common_axios(
        `${process.env.REACT_APP_COMMON_API}/auth/v1/credit/check-credit`
      );
      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        sethideSkeleton(false);
        setCredit(result.data.credit);
        // await setScheduleTotalCount(result.data.scheduledList.totalElements);

        // setData(result.data.scheduledList.content);
        // await toast.success("success", {n
        //   theme: "colored",
        //   toastId: customId1,
        // });
      } else {
        sethideSkeleton(false);
        // toast.error(result.data.statusDescription.statusMessage);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);
      sethideSkeleton(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  // .............................................................................//
  async function CreditIntervalBtn(values) {
    // setTableLoader(true);
    // sethideSkeleton(true);

    try {
      const result = await common_axios(
        `${process.env.REACT_APP_COMMON_API}/auth/v1/credit/check-credit`
      );
      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        //  sethideSkeleton(false);

        setCredit(result.data.credit);
        // setTimeout(() => {
        //   CreditIntervalBtn();
        // }, 10000);

        // setData(result.data.scheduledList.content);
        // await toast.success("success", {n
        //   theme: "colored",
        //   toastId: customId1,
        // });
      } else {
        //  sethideSkeleton(false);
        // toast.error(result.data.statusDescription.statusMessage);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);
      //  sethideSkeleton(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  useEffect(() => {
    CreditIntervalBtn();
  }, []);

  // ---------------------------------Credit api in setinterval-----------------------------------------

  const [intervalId, setIntervalId] = useState(null);

  useEffect(() => {
    const id = setInterval(() => {
      if (localStorage.getItem("token")) {
        CreditIntervalBtn();
      }
    }, 30000);
    setIntervalId(id);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    const handleRouteChange = () => {
      // Stop the setInterval when the user logs out and navigates to the login page
      clearInterval(intervalId);
    };

    history.listen(handleRouteChange);

    return () => {
      // history?.unlisten(handleRouteChange);
    };
  }, [history, intervalId]);

  // -----------------------------------End credit api in setinterval----------------------------------
  return (
    <>
      <header>
        <header
          class="header_1 py-1"
          style={{ position: "fixed", zIndex: "100" }}
        >
          <div class="container-fluid">
            <div class="d-flex header_main justify-content-between align-items-center">
              {/* <Link to="/" class="d-block w_8">
              <img src={FireLogo} class="img-fluid d-block" />
            </Link> */}
              <div className="d-flex align-items-center">
                <div>
                  <MenuIcon
                    id="iconNavbarSidenav2"
                    onClick={() => {
                      document.getElementById("thisButtonIsHidden").click();
                    }}
                    className="toggl_icon m-0 cursor-pointer me-2"
                  />
                </div>

                <Breadcrumbs />
              </div>

              <div class="d-flex align-items-center">
                {/* <span class="d-block text-capitalize me-2">
                Welcome [{localStorage.getItem("usernamedisplayed")}]
              </span> */}
                {/* {/ <span class="d-block text-capitalize">credit</span> /} */}
                <button
                  type="button"
                  className="btn w_btn m-0 px-0 search_1 refresh_credit1"
                  onClick={CreditRefreshBtn}
                >
                  <RefreshIcon />
                </button>
                {hideSkeleton == true ? (
                  <>
                    {" "}
                    <Box sx={{ width: 100 }}>
                      <Skeleton />
                      {/* <Skeleton /> */}
                      <Skeleton animation={false} />
                    </Box>
                  </>
                ) : (
                  <>
                    {/* <span className="d-block text-capitalize ms-1 me-2">
                      Credit :{" "}
                    </span>
                    <span
                      class="d-block text-capitalize icon_txt"
                      style={{
                        fontSize: "19px",
                        textShadow: "2px 2px #292a2d",
                      }}
                    >
                      {credit}
                    </span> */}


                    <span className="d-block text-capitalize ms-1 me-2">
                    Credit :{" "}
                  </span>
                  <span
                    class="d-block text-capitalize icon_txt"
                    style={{ fontSize: "19px" }}
                  >
                    {credit ? credit?.toLocaleString("en-US") : 0}
                  </span>

                    {credit < 1000 && (
                      <>
                        <Tooltip title="Low credit please recharge">
                          <IconButton className="IcButton">
                            <PriorityHighIcon className="err_ic" />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </>
                )}

                <div className="lining mx-2"></div>
                <span class="d-block text-capitalize">
                  {localStorage.getItem("usernamedisplayed")}
                </span>
                {/* <span
                class="d-block text-capitalize mx-2"
                style={{ fontSize: "21px", textShadow: "2px 2px #292a2d" }}
              >
                {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
                "ROLE_SUPER_ADMIN"
                  ? "₹12105.80"
                  : JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
                    "ROLE_RESELLER"
                  ? "₹15525.60"
                  : "₹7255.85"}
              </span>
              <span class="d-block text-capitalize me-2">
                {localStorage.getItem("usernamedisplayed")}
              </span> */}
                {/* <div class="dropdown mx-4">
                <a
                  class="btn btn_admin dropdown-toggle text-capitalize d-flex align-items-center p-0"
                  href="#"
                  role="button"
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span class="d-block me-1">admin</span>
                </a>

                <div
                  class="dropdown-menu sbn_mnq"
                  aria-labelledby="dropdownMenuLink"
                >
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i
                      class="fas fa-check fa-fw d-block"
                      aria-hidden="true"
                    ></i>
                    <span class="d-block w-100 ms-2">view assigned assets</span>
                  </div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i
                      class="fas fa-check fa-fw d-block"
                      aria-hidden="true"
                    ></i>
                    <span class="d-block w-100 ms-2">requested assets</span>
                  </div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i
                      class="fas fa-check fa-fw d-block"
                      aria-hidden="true"
                    ></i>
                    <span class="d-block w-100 ms-2">accept assets</span>
                  </div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i class="fas fa-user fa-fw d-block" aria-hidden="true"></i>
                    <span class="d-block w-100 ms-2">edit your profile</span>
                  </div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i class="fas fa-asterisk d-block" aria-hidden="true"></i>
                    <span class="d-block w-100 ms-2">change password</span>
                  </div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i
                      class="fas fa-user-secret d-block"
                      aria-hidden="true"
                    ></i>
                    <span class="d-block w-100 ms-2">manage API keys</span>
                  </div>
                  <div class="divider"></div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i
                      class="fa fa-sign-out fa-fw d-block"
                      aria-hidden="true"
                    ></i>
                    <span class="d-block w-100 ms-2">logout</span>
                  </div>
                </div>
              </div> */}

                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                  className="mx-1"
                  style={{ color: "#ffff" }}
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  // anchorOrigin={{
                  //   vertical: "bottom",
                  //   horizontal: "left",
                  // }}
                  // transformOrigin={{
                  //   vertical: "center",
                  //   horizontal: "right",
                  // }}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <Link to="/dashboard/profile">
                    <MenuItem onClick={handleClose}>View Profile</MenuItem>
                  </Link>
                  <MenuItem onClick={handleClick}>Sign Out</MenuItem>
                  {/* <Link to="/dashboard/updatepassword">
                      <MenuItem onClick={handleClose}>Update Password</MenuItem>
                    </Link>
                    <Link to="/dashboard/updateaccount">
                      <MenuItem onClick={handleClose}>Update account</MenuItem>
                    </Link> */}
                </Menu>
                {/* <Link to="/settings">
                <IconButton
                  variant="text"
                  size="small"
                  sx={{
                    color: "#ffff",
                  }}
                >
                  <SettingsIcon />
                </IconButton>
              </Link> */}

                <li
                  className="nav-item ps-3 d-lg-none d-flex align-items-center"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <a
                    className="nav-link text-body p-0"
                    id="iconNavbarSidenav"
                    style={{ cursor: "pointer" }}
                    onClick={() => setnavopen(!navopen)}
                  >
                    <div className="sidenav-toggler-inner">
                      <i className="sidenav-toggler-line"></i>
                      <i className="sidenav-toggler-line"></i>
                      <i className="sidenav-toggler-line"></i>
                    </div>
                  </a>
                </li>
              </div>
            </div>
          </div>
        </header>
        <header
          class="header_1 w-100 py-1"
          style={{ position: "static", opacity: "0" }}
        >
          <div class="container-fluid">
            <div class="d-flex justify-content-between align-items-center">
              <Link to="/" class="d-block w_8">
                <img src={FireLogo} class="img-fluid d-block" />
              </Link>

              <div class="d-flex align-items-center">
                {/* <span class="d-block text-capitalize me-2">
                Welcome [{localStorage.getItem("usernamedisplayed")}]
              </span> */}
                {/* {/ <span class="d-block text-capitalize">credit</span> /} */}
                <button
                  type="button"
                  className="btn w_btn m-0 px-0 search_1 refresh_credit1"
                  onClick={CreditRefreshBtn}
                >
                  <RefreshIcon />
                </button>
                {hideSkeleton == true ? (
                  <>
                    {" "}
                    <Box sx={{ width: 100 }}>
                      <Skeleton />
                      {/* <Skeleton /> */}
                      <Skeleton animation={false} />
                    </Box>
                  </>
                ) : (
                  <>
                    <span className="d-block text-capitalize ms-1 me-2">
                      Credit :{" "}
                    </span>
                    <span
                      class="d-block text-capitalize icon_txt"
                      style={{
                        fontSize: "19px",
                        textShadow: "2px 2px #292a2d",
                      }}
                    >
                      {credit}
                    </span>

                    {credit < 1000 && (
                      <>
                        <Tooltip title="Low credit please recharge">
                          <IconButton className="IcButton">
                            <PriorityHighIcon className="err_ic" />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </>
                )}

                <div className="lining mx-2"></div>
                <span class="d-block text-capitalize">
                  {localStorage.getItem("usernamedisplayed")}
                </span>
                {/* <span
                class="d-block text-capitalize mx-2"
                style={{ fontSize: "21px", textShadow: "2px 2px #292a2d" }}
              >
                {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
                "ROLE_SUPER_ADMIN"
                  ? "₹12105.80"
                  : JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
                    "ROLE_RESELLER"
                  ? "₹15525.60"
                  : "₹7255.85"}
              </span>
              <span class="d-block text-capitalize me-2">
                {localStorage.getItem("usernamedisplayed")}
              </span> */}
                {/* <div class="dropdown mx-4">
                <a
                  class="btn btn_admin dropdown-toggle text-capitalize d-flex align-items-center p-0"
                  href="#"
                  role="button"
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span class="d-block me-1">admin</span>
                </a>

                <div
                  class="dropdown-menu sbn_mnq"
                  aria-labelledby="dropdownMenuLink"
                >
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i
                      class="fas fa-check fa-fw d-block"
                      aria-hidden="true"
                    ></i>
                    <span class="d-block w-100 ms-2">view assigned assets</span>
                  </div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i
                      class="fas fa-check fa-fw d-block"
                      aria-hidden="true"
                    ></i>
                    <span class="d-block w-100 ms-2">requested assets</span>
                  </div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i
                      class="fas fa-check fa-fw d-block"
                      aria-hidden="true"
                    ></i>
                    <span class="d-block w-100 ms-2">accept assets</span>
                  </div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i class="fas fa-user fa-fw d-block" aria-hidden="true"></i>
                    <span class="d-block w-100 ms-2">edit your profile</span>
                  </div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i class="fas fa-asterisk d-block" aria-hidden="true"></i>
                    <span class="d-block w-100 ms-2">change password</span>
                  </div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i
                      class="fas fa-user-secret d-block"
                      aria-hidden="true"
                    ></i>
                    <span class="d-block w-100 ms-2">manage API keys</span>
                  </div>
                  <div class="divider"></div>
                  <div
                    class="dropdown-item d-flex align-items-center text-capitalize"
                    href="#"
                  >
                    <i
                      class="fa fa-sign-out fa-fw d-block"
                      aria-hidden="true"
                    ></i>
                    <span class="d-block w-100 ms-2">logout</span>
                  </div>
                </div>
              </div> */}

                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                  className="mx-1"
                  style={{ color: "#ffff" }}
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  // anchorOrigin={{
                  //   vertical: "bottom",
                  //   horizontal: "left",
                  // }}
                  // transformOrigin={{
                  //   vertical: "center",
                  //   horizontal: "right",
                  // }}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <Link to="/dashboard/profile">
                    <MenuItem onClick={handleClose}>View Profile</MenuItem>
                  </Link>
                  <MenuItem onClick={handleClick}>Sign Out</MenuItem>
                  {/* <Link to="/dashboard/updatepassword">
                      <MenuItem onClick={handleClose}>Update Password</MenuItem>
                    </Link>
                    <Link to="/dashboard/updateaccount">
                      <MenuItem onClick={handleClose}>Update account</MenuItem>
                    </Link> */}
                </Menu>
                {/* <Link to="/settings">
                <IconButton
                  variant="text"
                  size="small"
                  sx={{
                    color: "#ffff",
                  }}
                >
                  <SettingsIcon />
                </IconButton>
              </Link> */}

                <li
                  className="nav-item ps-3 d-lg-none d-flex align-items-center"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <a
                    className="nav-link text-body p-0"
                    id="iconNavbarSidenav"
                    style={{ cursor: "pointer" }}
                    onClick={() => setnavopen(!navopen)}
                  >
                    <div className="sidenav-toggler-inner">
                      <i className="sidenav-toggler-line"></i>
                      <i className="sidenav-toggler-line"></i>
                      <i className="sidenav-toggler-line"></i>
                    </div>
                  </a>
                </li>
              </div>
            </div>
          </div>
        </header>
      </header>
      <nav
        class="navbar navbar-main navbar-expand-lg px-0 shadow-none border-radius-xl my-2"
        id="navbarBlur"
        navbar-scroll="true"
      >
        <div class="container-fluid">
          {/* <Breadcrumbs /> */}

          {loki != "/dashboard/profile" ? (
            <>
              <div>
                {now.diff(date, "days") == -2 ? (
                  <>
                    <div
                      class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
                      role="alert"
                      style={{ marginBottom: "auto" }}
                    >
                      <div>
                        <strong>
                          Your Password would expire in
                          {/* {String(now.diff(date, "days")).split("-")[1]}  */}
                          2 Days
                        </strong>
                      </div>
                      <Link className="ms-3" to="/dashboard/profile">
                        Click Here .! <PanToolAltIcon />
                      </Link>
                      <button
                        style={{ color: "black" }}
                        type="button"
                        class="btn-close py-0"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                      ></button>
                    </div>
                  </>
                ) : now.diff(date, "days") == -1 ? (
                  <>
                    <div
                      class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
                      role="alert"
                      style={{ marginBottom: "auto" }}
                    >
                      <div>
                        <strong>
                          Your Password would expire in 1
                          {/* {String(now.diff(date, "days")).split("-")[1]}  */}
                          Day
                        </strong>
                      </div>
                      <Link className="ms-3" to="/dashboard/profile">
                        Click Here .! <PanToolAltIcon />
                      </Link>
                      <button
                        style={{ color: "black" }}
                        type="button"
                        class="btn-close py-0"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                      ></button>
                    </div>
                  </>
                ) : now.diff(date, "days") == 0 ? (
                  <>
                    <div
                      class="alert alert-warning alert-dismissible fade d-flex justify-content-between align-items-center show"
                      role="alert"
                      style={{ marginBottom: "auto" }}
                    >
                      <div>
                        <strong>Your Password will expire Today</strong>
                      </div>
                      <Link className="ms-3" to="/dashboard/profile">
                        Click Here .! <PanToolAltIcon />
                      </Link>
                      <button
                        style={{ color: "black" }}
                        type="button"
                        class="btn-close py-0"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                      ></button>
                    </div>
                  </>
                ) : null}
              </div>
            </>
          ) : null}
          {/* {passExpDays?.passExpIndays < 31 ? ( */}

          {/* {passExpDays?.passExpIndays < 31 ? (
            <>
              <Box sx={{ width: "100%" }}>
                <Collapse in={open}>
                  <Alert
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                    sx={{ mb: 2 }}
                  >
                    Close me!
                  </Alert>
                </Collapse>{" "}
              </Box>
            </>
          ) : (
            <>null</>
          )} */}

          {/* <div
            class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
            style={{ flexGrow: "unset" }}
            id="navbar"
          >
            <ul class="navbar-nav  justify-content-end">
              <li class="nav-item d-flex align-items-center">
                <a
                  href="javascript:;"
                  class="nav-link text-body font-weight-bold px-0"
                >
                  <i class="fa fa-user me-sm-1"></i>
                  <span class="d-sm-inline d-none">Welcome [superuser]</span>
                </a>
              </li>
              <li class="nav-item d-flex align-items-center px-3">
                <a
                  href="javascript:;"
                  class="nav-link text-body font-weight-bold px-0"
                >
                  <i class="fas fa-sign-out-alt fa-fw me-sm-1"></i>
                  <span class="d-sm-inline d-none">Sign Out</span>
                </a>
              </li>
              <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
                <a
                  href="javascript:;"
                  class="nav-link text-body p-0"
                  id="iconNavbarSidenav"
                >
                  <div class="sidenav-toggler-inner">
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                  </div>
                </a>
              </li>
            </ul>
          </div> */}

          <div
            class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
            style={{ flexGrow: "unset" }}
            id="navbar"
          >
            <ul class="navbar-nav  justify-content-end">
              {/* <li class="nav-item d-flex align-items-center">
                {truefalse && (
                  <>
                    {selectedTime.start ==
                    moment(new Date()).format("DD-MM-YYYY") ? (
                      <span
                        className="d-sm-inline ms_2 start_date_time_css"
                        style={{ backgroundColor: "#3c8dbc", color: "white" }}
                      >
                        Today
                      </span>
                    ) : selectedTime.start ==
                      moment(addDays(new Date(), -1)).format("DD-MM-YYYY") ? (
                      <span
                        style={{ backgroundColor: "#3c8dbc", color: "white" }}
                        className="d-sm-inline ms_2 start_date_time_css"
                      >
                        Yesterday
                      </span>
                    ) : (
                      <>
                        <span
                          style={{ backgroundColor: "#3c8dbc", color: "white" }}
                          className="d-sm-inline ms_2 start_date_time_css"
                        >
                          {selectedTime.start}
                        </span>
                        <ForwardIcon />
                        <span
                          style={{ backgroundColor: "#3c8dbc", color: "white" }}
                          className="d-sm-inline mx_2 start_date_time_css"
                        >
                          {selectedTime.end}
                        </span>
                      </>
                    )}
                    <IconButton
                      variant="text"
                      size="small"
                      sx={{
                        color: "rgba(0, 0, 0, 0.6)",
                      }}
                      // className="btn bg-gradient-primary "
                      aria-describedby={
                        Boolean(anchorEll) ? "simple-popover" : undefined
                      }
                      onClick={(event) => {
                        setAnchorEll(event.currentTarget);
                      }}
                    >
                      <CalendarMonthIcon />
                    </IconButton>

                    <Popover
                      id={Boolean(anchorEll) ? "simple-popover" : undefined}
                      open={Boolean(anchorEll)}
                      anchorEl={anchorEll}
                      onClose={() => {
                        setAnchorEll(null);
                      }}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                    >
                      <DateRangePickerr />
                    </Popover>
                  </>
                )}
              </li> */}

              <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
                <a
                  href="javascript:;"
                  class="nav-link text-body p-0"
                  id="iconNavbarSidenav"
                >
                  <div class="sidenav-toggler-inner">
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <nav
        className="navbar navbar-main navbar-expand-lg px-0 shadow-none border-radius-xl heading_1 d-none"
        id="navbarBlur"
        navbar-scroll="true"
      >
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>

        <div className="container-fluid">
          <nav aria-label="breadcrumb" className="bread">
            <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
              <li className="breadcrumb-item text-sm">
                <Breadcrumbs />
              </li>
            </ol>
          </nav>
          {/* <nav aria-label="breadcrumb">
              <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
                <li class="breadcrumb-item text-sm">
                  <a class="opacity-5 text-dark" href="javascript:;">
                    MIS Account
                  </a>
                </li>
                <li
                  class="breadcrumb-item text-sm text-dark active"
                  aria-current="page"
                >
                  Add Account
                </li>
              </ol>
            </nav> */}

          <div
            className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 justify-content-end"
            id="navbar"
          >
            <ul className="navbar-nav  justify-content-end">
              <li className="nav-item d-flex align-items-center me-2">
                <a href="" className="nav-link text-body font-weight-bold px-0">
                  <i className="fa fa-user me-sm-1"></i>
                  <span className="d-sm-inline ms_2">
                    Welcome [{localStorage.getItem("usernamedisplayed")}]
                  </span>
                </a>
              </li>
              {/* <button
                onClick={handleClick}
                id="logout"
                key="logout"
                className="nav-link text-body font-weight-bold ms_2 px-0"
                style={{ border: "none", marginLeft: "10px" }}
              >
                <i className="fas fa-sign-out-alt fa-fw me-sm-1"></i>
                <span className="d-sm-inline d-none">Sign Out</span>
              </button> */}
              {truefalse && (
                <>
                  <span className="d-sm-inline ms_2">{selectedTime.start}</span>
                  <span className="d-sm-inline ms_2">{selectedTime.end}</span>
                  <IconButton
                    variant="text"
                    size="small"
                    sx={{
                      color: "#7B809A",
                    }}
                    // className="btn bg-gradient-primary "
                    aria-describedby={
                      Boolean(anchorEll) ? "simple-popover" : undefined
                    }
                    onClick={(event) => {
                      setAnchorEll(event.currentTarget);
                    }}
                  >
                    <CalendarMonthIcon />
                  </IconButton>

                  <Popover
                    id={Boolean(anchorEll) ? "simple-popover" : undefined}
                    open={Boolean(anchorEll)}
                    anchorEl={anchorEll}
                    onClose={() => {
                      setAnchorEll(null);
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <DateRangePickerr />
                  </Popover>
                </>
              )}

              <li
                className="nav-item ps-3 d-lg-none d-flex align-items-center"
                onClick={() => setIsOpen(!isOpen)}
              >
                <a
                  className="nav-link text-body p-0"
                  id="iconNavbarSidenav"
                  style={{ cursor: "pointer" }}
                  onClick={() => setnavopen(!navopen)}
                >
                  <div className="sidenav-toggler-inner">
                    <i className="sidenav-toggler-line"></i>
                    <i className="sidenav-toggler-line"></i>
                    <i className="sidenav-toggler-line"></i>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

const mapStateToProps = (state) =>
  // console.log(state, "state"),
  ({
    username: state.authReducer.username,
  });

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout(localStorage.getItem("Username"))),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));
